(function () {
  "use strict";

  const PRICE_SELECTORS = [
    ".price-item__group.price",
    ".price-item--sale",
    ".price-item--regular",
    ".price-item",
    ".compare-at-price",
    "product-price .price",
    ".product-card__price .price",
    ".price__regular",
    ".price__sale"
  ].join(",");

  const PRICE_CONTAINERS =
    ".price, .price-item__group, .price__container, .product-card__price, product-price";

  const CURRENCY_TEST = /(?:Rs\.?|INR)\s*[\d,]+/i;

  function convertText(str) {
    return str
      .replace(/Rs\.\s*/gi, "\u20B9")
      .replace(/\bRs\s*/gi, "\u20B9")
      .replace(/\bINR\s*/gi, "\u20B9");
  }

  function replaceCurrencyText(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        const parent = node.parentElement;
        if (parent && ["SCRIPT", "STYLE", "NOSCRIPT", "TEMPLATE"].includes(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return CURRENCY_TEST.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      node.nodeValue = convertText(node.nodeValue);
    });
  }

  function isComparePrice(el) {
    if (el.classList.contains("compare-at-price") || el.closest("s, del")) return true;
    if (el.classList.contains("price-item--regular")) {
      const block = el.closest(".price, .price__container, product-price");
      if (block && block.querySelector(".price-item--sale")) return true;
    }
    return false;
  }

  function styleCurrent(el) {
    el.style.fontWeight = "700";
    el.style.color = "#111";
    el.style.letterSpacing = "0";
    el.style.textDecoration = "none";
    el.style.opacity = "1";
  }

  function styleCompare(el) {
    el.style.fontWeight = "300";
    el.style.color = "#888";
    el.style.textDecoration = "line-through";
    el.style.textDecorationThickness = "1px";
    el.style.opacity = "0.7";
  }

  function stylePrices(root) {
    if (!root) return;
    const list = [];
    if (root.matches && root.matches(PRICE_SELECTORS)) list.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll(PRICE_SELECTORS).forEach(function (p) {
        list.push(p);
      });
    }
    list.forEach(function (price) {
      if (!isComparePrice(price)) styleCurrent(price);
    });
    list.forEach(function (price) {
      if (isComparePrice(price)) styleCompare(price);
    });
  }

  function fixPriceOrder(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(PRICE_CONTAINERS).forEach(function (group) {
      const salePrice = group.querySelector(
        ".price-item--sale, .price-item__sale, .price-item__group.price"
      );
      const comparePrice = group.querySelector(
        ".price-item--regular.compare-at-price, .compare-at-price"
      );
      if (!salePrice || !comparePrice) return;
      if (salePrice === comparePrice) return;
      if (salePrice.contains(comparePrice) || comparePrice.contains(salePrice)) return;
      group.style.display = "flex";
      group.style.flexWrap = "wrap";
      group.style.alignItems = "baseline";
      group.style.columnGap = "6px";
      salePrice.style.order = "1";
      comparePrice.style.order = "2";
      comparePrice.style.marginRight = "0";
      salePrice.style.marginRight = "0";
    });
  }

  function processPrices(root) {
    if (!root) return;
    replaceCurrencyText(root);
    stylePrices(root);
    fixPriceOrder(root);
  }

  // Process only the nodes that actually changed (never the whole body again)
  function handleNode(node) {
    if (!node.isConnected) return;

    if (node.nodeType === Node.TEXT_NODE) {
      if (CURRENCY_TEST.test(node.nodeValue)) node.nodeValue = convertText(node.nodeValue);
      const parent = node.parentElement;
      const container = parent && parent.closest(PRICE_CONTAINERS);
      if (container) processPrices(container);
      return;
    }

    processPrices(node);
  }

  function init() {
    processPrices(document.body);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Batched observer: collects changed nodes, handles them once per frame,
  // and is paused while we edit so our own edits never re-trigger it.
  const queue = new Set();
  let scheduled = false;

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE) {
            queue.add(node);
          }
        });
      } else if (mutation.type === "characterData") {
        queue.add(mutation.target);
      }
    });
    if (queue.size && !scheduled) {
      scheduled = true;
      requestAnimationFrame(flush);
    }
  });

  function startObserver() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function flush() {
    scheduled = false;
    const nodes = Array.from(queue);
    queue.clear();
    observer.disconnect();
    nodes.forEach(handleNode);
    startObserver();
  }

  if (document.body) {
    startObserver();
  } else {
    document.addEventListener("DOMContentLoaded", startObserver);
  }

  document.addEventListener("shopify:section:load", function (event) {
    processPrices(event.target);
  });

  document.addEventListener("shopify:section:reorder", function () {
    processPrices(document.body);
  });

  document.addEventListener("shopify:block:select", function () {
    processPrices(document.body);
  });

  document.addEventListener(
    "input",
    function (event) {
      const target = event.target;
      if (
        target &&
        (target.matches('input[type="search"]') ||
          target.matches('input[name="q"]') ||
          target.closest("search-modal") ||
          target.closest(".search-modal"))
      ) {
        const scope = target.closest("search-modal, .search-modal") || document.body;
        [50, 200, 500].forEach(function (ms) {
          setTimeout(function () {
            processPrices(scope);
          }, ms);
        });
      }
    },
    true
  );
})();
